import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@Component({
  imports: [CommonModule, MatDialogModule, MatButtonModule, GalaxyFormFieldModule, MatInputModule, TranslateModule],
  templateUrl: './pending-activation-approval-dialogue.component.html',
  styleUrls: ['./pending-activation-approval-dialogue.component.scss'],
})
export class PendingActivationApprovalDialogueComponent {
  constructor(private dialogue: MatDialogRef<PendingActivationApprovalDialogueComponent>) {}

  handleClick() {
    this.dialogue.close(true);
  }
}
